import { getDomain } from '@utils/EnvironmentUtil'
import * as StoreProgramService from '@services/StoreProgramService'
import * as FeatureConfigService from '@services/FeatureConfigService'

const RIVER = {
    TEST: 'https://sb.integ.river.amazonoperations.app',
    VERDE: 'https://sb.river.amazonoperations.app',
}

/**
 * Service that manages the river menu feature. River is a web based self-service tool for resolving
 * issues by following interactive decision trees and workflows. It is a unified troubleshooting
 * and ticket creation tool. See details here: https://w.amazon.com/bin/view/RIVER/
 *
 * If it's prod and associate is verde, "River" section will show up before
 * "Change Language" section, if clicked, it will redirect to the external RIVER login page.
 */
export const getExternalRiverURL = () => {
    if (isRiverEnabled()) {
        console.info('Retrieving Verde River URL..')
        if (getDomain() === 'prod') {
            return RIVER.VERDE
        } else {
            return RIVER.TEST
        }
    }
    return null
}

export const isRiverEnabled = () => {
    return StoreProgramService.isVerdeAssociate() &&
        FeatureConfigService.isFeatureEnabled(FeatureConfigService.featureConfigFeatures.ENABLE_RIVER_FEATURE, false)
}
